import React, { Fragment } from 'react'
import { Row, Col } from 'react-flexbox-grid'
import { isNumeric } from 'validator'
import { Form, Number, Text, Checkbox, DateTimePicker, Select } from 'components/forms'
import Button from 'components/Button'
import Divider from 'components/Divider'
import { ContentBlock } from 'components/ContentBlock'
import { ImageUploaderGraphql } from 'components/Image'
import { notEmpty } from 'helpers/validators'
import { useTranslation } from 'react-i18next'
import get from 'lodash/get'
import query from '../gql/getUser'
import { listShops } from 'gql/query'

const User = ({ data, itemId, onChangeMultiEdit, apiRef, formData, newRecord, ConfirmButton, ConfirmModal, appData, mutations: { createItem, updateItem }, multiEdit }) => {
	const [t] = useTranslation()
	const imgKey = get(data, 'img.key', '')

	const validatePassword = val => {
		if(val && !isNumeric(val)) {
			return t('validators.only_numbers')
		}
		if(val && val.length !== 4) {
			return t('validators.required_4_symbols')
		}
	}

	return(
		<ContentBlock>
			<Form
				apiRef={apiRef}
				onChange={(e) => multiEdit?.isActive && onChangeMultiEdit(e, formData)}
				smartSubmit={(!newRecord && !multiEdit?.isActive)}
				initialValues={formData}
				onSubmit={newRecord ? createItem : updateItem}
				render={({ formState }) => (
					<Fragment>
						<Row>
							<Col xs={4}>
								<div>
									<Text
										inline={true}
										readOnly={multiEdit.isActive}
										label={t('common.fields.code')}
										field='code'
										placeholder={t('common.placeholders.number')} {...notEmpty()} validateOnChange />
									<Checkbox inline={true}
										label={t('common.fields.isActive')}
										field='isActive'
									/>
									{ConfirmModal()}
								</div>
								<Text
									label={t('user_section.fields.name')}
									readOnly={multiEdit.isActive}
									field='name'
									placeholder={t('common.placeholders.name')} {...notEmpty()} validateOnChange />
								<Text
									label={t('user_section.fields.short_name')}
									field='shortName'
								/>
								 <Text
									label={t('user_section.fields.bill_name')}
									field='printName'
								/>
								{appData.isShopFieldActive &&
									<Select
										label={t('common.fields.shop_affiliation')}
										field='shopId'
										valueField='id'
										labelField='name'
										validate={val => !val && appData.shopAccess ? t('validators.required') : null}
										remoteOptions={{
											query: listShops,
											modifyOptions: (options => {
												return options
													.map(opt => opt.codePrefix ? ({ ...opt, name: `${opt.name} - "${opt.codePrefix}"` }) : opt)
											})
										}}
										isClearable={!appData.shopAccess}
									/>
								}
							</Col>
							<Col xs={4}>
								<DateTimePicker
									field='dateInterval'
									interval
									picker='date'
									label={t('user_section.fields.active_period')}
									placeholder={{ from: t('common.placeholders.from_date'), to: t('common.placeholders.to_date') }}
								/>
								<Text
									label={t('user_section.fields.pin', {'defaultValue': 'PIN'})}
									type='password'
									field='password'
									disablePasswordAutoComplete
									pwdVisibilityBtn
									validateOnChange
									validate={validatePassword}
								/>
								<Number
									label={t('user_section.fields.performance')}
									field='performance'
									placeholder={t('user_section.placeholders.performance')}
								/>
								{appData.e2nIntegrationActive &&
									<Text
										label='E2N Security-Token'
										field='timeTrackingId'
										validateOnChange
										validate={val => !val || (val && val.length === 13) ? null : 'Muss 13-stellig sein'}
									/>
								}
							</Col>
							<Col xs={4}>
								<ImageUploaderGraphql
									id={itemId}
									getQuery={query}
									type='User'
									imgKey={imgKey}
									label={t('user_section.fields.userphoto')}
									width={512}
									height={512}
									isRound={true}
								/>
							</Col>
						</Row>
						{ConfirmButton(formState)}
						{newRecord &&
							<Fragment>
								<Divider height={40}/>
								<Col type='row'>
									<Button
										type='submit'
										status='primary'
										text={t('common.buttons.create')}/>
								</Col>
							</Fragment>
						}
					</Fragment>
				)}/>
		</ContentBlock>
	)
}

export default User
